<!--
 * @Description: 全局字段树结构
 * @Version: 2.0
 * @Autor: 胡彩丽 hucaili@qfei.cn
 * @LastEditors: 胡彩丽 hucaili@qfei.cn
-->
<template>
  <li v-for="nodeData in treeData" :key="nodeData.id" :class="[nodeData?.level == 3 ? 'nodeDataMr' : (nodeData?.level == 1 || nodeData?.level == 2) && !nodeData?.children?.length ? 'nodeDataMrP' : 'nodeDataMrP2']">
    <icon-caret-down v-if="nodeData?.isOpen && nodeData?.children?.length" @click.stop="openUl(nodeData)" class="icon-caret" />
    <icon-caret-right v-if="!nodeData?.isOpen && nodeData?.children?.length" @click.stop="openUl(nodeData)" class="icon-caret" />
    <jw-input @blur="blurData" v-model="nodeData.label" :style="{ width: '180px', marginRight: '10px' }" :placeholder="nodeData.level == 1 ? $t('请输入一级选项名称') : nodeData.level == 2 ? $t('请输入二级选项名称') : nodeData.level == 3 ? $t('请输入三级选项名称') : ''"></jw-input>
    <jw-input @blur="blurData" v-model="nodeData.value" :disabled="nodeData.id ? true : false" @keyup="nodeData.value = nodeData.value.replace(/[\u4E00-\u9FA5]|\s+/g, '')" :style="{ width: '120px', marginRight: '10px' }" :placeholder="$t('请输入key值')"></jw-input>
    <icon-minus-circle size="20" v-if="(treeData.length > 1 || nodeData.level > 1) && nodeData.id == ''" class="minus-icon" @click="onRemoveTree(nodeData)" />
    <template v-if="nodeData.id">
      <jw-switch v-if="type !== 'add'" v-model="nodeData.isEnabled" @change="updateIsenabled">
        <template #checked> {{ $t('启用') }} </template>
        <template #unchecked> {{ $t('停用') }} </template>
      </jw-switch>
    </template>
    <icon-plus-circle size="20" v-if="nodeData.level < level && nodeData.id == ''" class="plus-icon" @click="onAddTree(nodeData)" />

    <!-- 当没有children的时候，就不用走递归了。-->
    <ul v-if="nodeData?.children && nodeData?.children?.length" v-show="nodeData?.isOpen">
      <xl-global-tree :options="nodeData.children"></xl-global-tree>
    </ul>
  </li>
</template>
<script setup>
import { reactive, inject } from 'vue';
import { tools } from '@/utils/tools.js';
const props = defineProps({
  options: {
    //默认选项值
    type: Array,
    default() {
      return [{ key: '0-0', level: 1, label: '', value: '', id: '', isEnabled: true, isOpen: true }];
    }
  }
});
const emits = defineEmits(['update']);
const treeData = reactive(props.options);
const level = inject('defaultParams').level; //限制级联选择器层级
const type = inject('defaultParams').type; //add-新增 edit-编辑
//添加级联选项
const onAddTree = (nodeData) => {
  // console.log(nodeData);
  const children = nodeData.children || [];
  const tool = tools.randomString();
  children.push({
    key: nodeData.key + '-' + (children.length + 1),
    isOpen: true,
    level: nodeData.level + 1,
    label: '',
    value: `${tool}`,
    id: '',
    isEnabled: true
  });
  nodeData.children = children;
  console.log('treeData', treeData);
  emits('update', treeData);
};
const updateIsenabled = () => {
  emits('update', treeData);
};
//删除选项
const onRemoveTree = (nodeData) => {
  remove(nodeData, treeData);
  emits('update', treeData);
};
const openUl = (item) => {
  item.isOpen = !item.isOpen;
};
// 删除
const remove = (nodeData, treeData) => {
  for (let i = 0; i < treeData.length; i++) {
    if (treeData[i].key == nodeData.key) {
      treeData.splice(i, 1);
      break;
    }

    if (treeData[i].children && treeData[i].children.length) {
      remove(nodeData, treeData[i].children);
    }
  }
};
const blurData = () => {
  emits('update', treeData);
};
</script>

<style scoped lang="less">
@import './xl-global-tree.less';
</style>
